<template>
  <div class="dialog-wrap">
    <el-dialog title="分数线"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :modal-append-to-body="false"
               @open="open"
               width="80%">
      <div class="values">
        <div style="display:flex;justify-content: space-between; min-height:70px">
          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <el-form-item label="年份"
                          prop="year">
              <el-select v-model="year"
                         clearable
                         style="width:90px;marginLeft:10px"
                         placeholder="请选择"
                         @change="fetchList(true)">
                <el-option label="2027年"
                           value="2027"></el-option>
                <el-option label="2026年"
                           value="2026"></el-option>
                <el-option label="2025年"
                           value="2025"></el-option>
                <el-option label="2024年"
                           value="2024"></el-option>
                <el-option label="2023年"
                           value="2023"></el-option>
                <el-option label="2022年"
                           value="2022"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校名称"
                          prop="college_name">
              <el-select v-model="college_keyword"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         clearable
                         @change="fetchList(true)">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院"
                          prop="reamrk">
              <el-select v-model="apply_academy"
                         placeholder="请选择院校"
                         clearable
                         filterable
                         @change="academyChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in academyList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="reamrk">
              <el-select v-model="apply_major"
                         placeholder="请选择专业"
                         clearable
                         filterable
                         @change="majorChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in majorList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 方向筛选（已按需求注释保留）：
            <el-form-item label="方向：">
              <el-select v-model="query.direction_code"
                         filterable
                         clearable
                         collapse-tags
                         placeholder="请选择"
                         @change="fetchList(true)">
                <el-option v-for="(item, index) in directionList"
                           :key="index"
                           :label="item.direction"
                           :value="item.direction_code">
                  <span>{{ `${item.direction}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            -->
          </el-form>

          <div style="display:flex; height:30px">
            <div class="btBox">
              <el-button plain
                         style="marginRight:10px"
                         @click="handleDownload"
                         type="primary">下载模板</el-button>
              <input @change="upload"
                     type="file"
                     name="photoImg"
                     id="getFile"
                     style="display:none;"
                     class="upload-input" />
              <label for="getFile"
                     class="fileStyle">导入</label>

            </div>
            <el-button class="button"
                       @click="adjustAdd"
                       type="primary">新建</el-button>
          </div>
        </div>
        <el-table class="table"
                  :data="results"
                  border
                  @selection-change="handleSelectionChange"
                  style="width: 100%">
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column label="院校"
                           align="center"
                           show-overflow-tooltip
                           width="120px">
            <template slot-scope="scope">
              {{ fmt(scope.row.college_name) }}
            </template>
          </el-table-column>
          <el-table-column label="学院"
                           width="200px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.academy_code, scope.row.academy_name, '(', ')') }}
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           align="center"
                           width="200px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.major_code, scope.row.major_name, '[', ']') }}
            </template>
          </el-table-column>

          <el-table-column label="方向"
                           width="200px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.direction_code, scope.row.direction_name, '(', ')') }}
            </template>
          </el-table-column>
          <el-table-column prop="score_total"
                           label="总分"
                           width="100"
                           align="center"> <template slot-scope="scope">
              {{ fmtScore(scope.row.score_total) }}
            </template>
          </el-table-column>
          <el-table-column prop="score_politics"
                           label="政治"
                           width="100"
                           align="center"> <template slot-scope="scope">
              {{ fmtScore(scope.row.score_politics) }}
            </template>
          </el-table-column>
          <el-table-column prop="score_language"
                           label="外语"
                           width="100"
                           align="center"> <template slot-scope="scope">
              {{ fmtScore(scope.row.score_language) }}
            </template>
          </el-table-column>
          <el-table-column prop="score_business_1"
                           label="业务课一"
                           width="100"
                           align="center"> <template slot-scope="scope">
              {{ fmtScore(scope.row.score_business_1) }}
            </template>
          </el-table-column>
          <el-table-column prop="score_business_2"
                           label="业务课二"
                           width="100"
                           align="center"> <template slot-scope="scope">
              {{ fmtScore(scope.row.score_business_2) }}
            </template>
          </el-table-column>

          <el-table-column label="最新更新人"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmt(scope.row.last_update_admin_nickname) }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ fmtTime(scope.row.update_time) }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right"
                           label="操作"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleToRemove(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div>
          <el-button size="mini"
                     type="danger"
                     @click="handleToDeleteAll()">批量删除</el-button>
        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <AddGradeLine :visible="createDialog"
                    :detail="detail"
                    @close="createDialog=false"
                    @submit="submitFetchList"></AddGradeLine>
      <EditGradeLine :visible="editDialog"
                     @close="editDialog=false"
                     :detail="detail"
                     :editId="editId"
                     @submit="submitFetchList"></EditGradeLine>
    </el-dialog>
  </div>
</template>

<script>
import AddGradeLine from '@/components/dialog/admission/addGradeLine'
import EditGradeLine from '@/components/dialog/admission/editGradeLine.vue'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  // majorinfo, // 方向筛选下拉接口（已按需求注释）
} from '@/api/common'
import { scoreLine, scoreLineDelete, scoreLinelmport } from '@/api/admission'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    gradeDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    year: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    gradeDetail(val) {
      this.detail = val
      this.$set(this.apply_major, 'value', val.major_code)
      this.college_keyword = val.college_code
    },
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
        this.fetchList(true)
      }
    },
  },
  components: {
    AddGradeLine,
    EditGradeLine,
  },
  data() {
    return {
      detail: {},
      // senior: {}, // 编辑遗留死代码（仅 directionChange 使用），随方向筛选一并注释
      // directionList: [], // 方向筛选下拉数据（已按需求注释）
      dialogVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        year: '2025',
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
      createDialog: false,
      editDialog: false,
      editId: null,
      filter: {
        years: [
          { label: '2027年考研', value: 2027 },
          { label: '2026年考研', value: 2026 },
          { label: '2025年考研', value: 2025 },
          { label: '2024年考研', value: 2024 },
          { label: '2023年考研', value: 2023 },
        ],
        enrol_types: [
          { label: '全日制', value: 1 },
          { label: '非全日制', value: 2 },
        ],
        delete_types: [
          { label: '上线', value: 0 },
          { label: '下线', value: 2 },
        ],
      },
      majorList: [],
      academyList: [],
      apply_major: { value: '', label: '' },
      apply_academy: {},
      college_keyword: '',
    }
  },

  methods: {
    fmt(val) {
      if (val === null || val === undefined) return '--'
      const s = String(val).trim()
      return s === '' ? '--' : val
    },
    fmtCodeName(code, name, left, right) {
      const c = String(code || '').trim()
      const n = String(name || '').trim()
      if (!c && !n) return '--'
      return (c ? `${left}${c}${right}` : '') + n
    },
    fmtScore(val) {
      if (val === null || val === undefined) return '--'
      const s = String(val).trim()
      if (s === '') return '--'
      return `${val}分`
    },
    fmtTime(time, format) {
      if (time === null || time === undefined) return '--'
      const s = String(time).trim()
      if (s === '') return '--'
      return this.$moment(time).format(format || 'YYYY.MM.DD HH:mm')
    },
    academyChange() {
      this.fetchList(true)
    },
    majorChange() {
      this.fetchList(true)
    },
    // 专业
    Majorists() {
      collegeMajorList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list
      })
    },
    // 院校
    getAcademyList() {
      academyList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.academyList = res.list
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })
        scoreLineDelete({ ids }).then((res) => {
          this.$message.success('删除成功')
          this.fetchList(true)
        })
      })
    },
    handleDownload() {
      // 旧地址：https://upload.kaoyanbox.net/437a14ea31c0779f038793a83a63aaca.xlsx
      let url =
        'https://upload.kaoyanbox.net/782c420f0cdf50e950d379a9fa92ad9c.xlsx'
      let filename = '分数线名单文件导入示例文件.xlsx'
      var ajax = new XMLHttpRequest()
      ajax.open('GET', url, true)
      ajax.responseType = 'blob'
      ajax.onload = (e) => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) {
          //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },
    changeYear() {
      console.log('year', this.query)
      this.fetchList(true)
    },
    /* 方向筛选相关逻辑（已按需求注释保留）：
    directionChange(e) {
      this.senior.recruit_direction_name = this.directionList.find((item) => {
        return item.direction_code === e //筛选出匹配数据
      }).direction
    },
    // 录取方向
    majorDirect(college_code, major_code) {
      majorinfo({
        isPaging: 0,
        college_code: college_code,
        major_code: major_code,
      }).then((res) => {
        if (res.academys && res.academys.length) {
          let list = res.academys.map((item) => item.directions).flat()
          let obj = {}
          for (let item of list) {
            if (!obj[item.direction_code]) {
              obj[item.direction_code] = item
            }
          }
          this.directionList = Object.values(obj)
          console.log(this.directionList, 'this.directionList')
        }
      })
    },
    */
    submitFetchList() {
      this.fetchList(true)
    },
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', file)

        scoreLinelmport(formData).then((res) => {
          if (res == null) {
            this.$message.success(`导入成功`)
            this.fetchList(true)
          }
        })
      }
    },
    adjustAdd() {
      this.createDialog = true
    },
    handleClose() {
      this.apply_major = {}
      this.apply_academy = {}
      this.$emit('close')
      this.query.pageIndex = 1
    },
    open() {
      this.fetchList()
      this.Majorists()
      this.getAcademyList()
      // this.majorDirect(this.detail.college_code, this.detail.major_code) // 方向筛选下拉加载（已按需求注释）
    },
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      params.year = this.year
      params.college_code = this.college_keyword
      params.academy_code = this.apply_academy.value
      params.major_code = this.apply_major.value
      scoreLine(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },

    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.creators && this.query.creators.length) {
        this.query.creators = this.query.creators.split(',').map((v) => {
          return Number(v)
        })
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      if (params.creators) {
        params.creators = params.creators.filter((v) => v).join(',')
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    collegeChange(e) {
      if (e) {
        this.fetchMajor(e)
      }
      setTimeout(() => {
        this.fetchList(true)
      }, 500)
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    majorChange(e) {
      if (e) {
        this.fetchAcademy(this.query.college_code, e)
      }
      setTimeout(() => {
        this.fetchList(true)
      }, 500)
    },
    fetchAcademy(college_code, major_code) {
      academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.list
      })
    },
    handleToRemove(id) {
      let data = {
        ids: [id],
      }
      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        scoreLineDelete(data).then((res) => {
          this.fetchList(true)
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.fileStyle {
  position: relative;

  margin-right: 5px;
  border-radius: 1px;
  padding: 6px 15px;
  color: #999999;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999999;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
